import { render, staticRenderFns } from "./threeColumns.vue?vue&type=template&id=f43af644"
import script from "./threeColumns.vue?vue&type=script&lang=js"
export * from "./threeColumns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports